import React from 'react';
import { Panel, PanelGroup } from "react-resizable-panels";
import ResizeHandle from './ResizeHandle';
import ActiveSwarmsTabs from './ActiveSwarmsTabs';
import PendingBuyRequests from './pendingBuyRequests/PendingBuyRequests';
import styles from '../styles.module.css';

export function MainContent() {
  return (
    <div className={styles.MainContent}>
      <PanelGroup direction="horizontal">
        <Panel className={styles.Panel} defaultSize={58}>
          <ActiveSwarmsTabs />
        </Panel>
        <ResizeHandle />
        <Panel className={styles.Panel} defaultSize={42}>
          <PendingBuyRequests/>
        </Panel>
      </PanelGroup>
    </div>
  );
};
